module.exports = __webpack_public_path__ + "img/tab-chat-inactive.9da46f3.png";